import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, styled } from '@mui/material'
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from 'react-router'
import ChangesTable from './ChangesTable';
import { editChannelData } from '../../utilities/apiRequests';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {padding: theme.spacing(2)},
    '& .MuiDialogActions-root': {padding: theme.spacing(1)},
}));

export default function ConfirmationScreen({...params}){

    let confirmationScreenState = params.confirmationScreenState
    let closeConfirmationScreen = params.closeConfirmationScreen
    let oldValues = params.oldValues
    let newValues = params.newValues
    let channelAttributeNames = params.channelAttributeNames
    let channelID = params.channelID
    let nameToIndex = params.nameToIndex

    const navigate = useNavigate()
    const { getAccessTokenSilently } = useAuth0();

    function closeScreen(event){
        event.preventDefault()
        closeConfirmationScreen()
    }

    async function submitButtonOnClick(event){
        event.preventDefault()

        const token = await getAccessTokenSilently({ authorizationParams: { scope: "write:channels" } })
        let updates = getUpdates(oldValues, newValues, channelAttributeNames, nameToIndex)
        await editChannelData(channelID, token, updates)
        sessionStorage.removeItem('rows')

        navigate("/stationspage")
    }


    return (
        <BootstrapDialog onClose={closeScreen} open={confirmationScreenState} fullWidth={true} maxWidth={'xl'}>
            <DialogTitle textAlign={'center'} padding={1}>
                STAGED CHANGES
            </DialogTitle>

            <DialogContent dividers>
                <ChangesTable
                    channelAttributeNames={channelAttributeNames}
                    newValues={newValues}
                    oldValues={oldValues}
                />
            </DialogContent>

            <DialogActions sx={{justifyContent: 'center'}}>
                <Stack direction={"row"} alignItems={"left"} justifyContent={"left"} flexDirection={"row"} spacing={'20%'}>
                    <Button variant={'outlined'} onClick={closeScreen}>Back</Button>
                    <Button variant={'outlined'} onClick={submitButtonOnClick}>Submit</Button>
                </Stack>
            </DialogActions>
        </BootstrapDialog>
    )
}

function getUpdates(oldValues, newValues, channelAttributeNames, nameToIndex){

    let updates = {}

    for(let i = 0; i < oldValues.length; i++){
        let oldValue = oldValues[i]
        let newValue = newValues[i]

        if (oldValue !== newValue){
            if (newValue === 'True') newValue = true
            if (newValue === 'False') newValue = false
            if (typeof newValue === "string" && newValue.trim() === "") newValue = null
            let channelAttributeName = channelAttributeNames[i]
            updates[channelAttributeName] = newValue
        }
    }

    /*
    let callSignIsUpdated = Object.hasOwn(updates, 'call_sign') 
    let affiliateIsUpdated = Object.hasOwn(updates, 'affiliate')

    if (callSignIsUpdated && affiliateIsUpdated) updates['channel_id'] = (updates['call_sign'] + "-" + updates['affiliate']).toLowerCase()
    else if (callSignIsUpdated) updates['channel_id'] = (updates['call_sign'] + "-" + oldValues[nameToIndex['affiliate']]).toLowerCase()
    else if (affiliateIsUpdated) updates['channel_id'] = (oldValues[nameToIndex['call_sign']] + "-" + updates['affiliate']).toLowerCase()
    */

    return updates
}
